import React from 'react'
import * as blocks from 'blocks'
import {rafThrottle, nullCheckProps} from 'utils'
import {getComponentDisplayName} from "../../utils";

export {rafThrottle}

/**
 * @param {Object} props - True sets columns to full width.
 * @param {Function} additionalProps - Return props as a function of index.
 * @returns {Array} Array of React Component
 */
export const childParser = ({children, components}, additionalProps = () => false) => {
  if (children) {
    return React.Children.map(children, (child, index) => {
      if (!child) return null
      if (additionalProps) {
        return React.cloneElement(child, additionalProps(index))
      }
      return child
    })
  }
  
  if (components) {
    return components.map(({name, props}, index) =>
      renderComponent({
        name,
        props: {
          ...nullCheckProps(props),
          ...additionalProps(index),
          key: index,
        },
      }))
  }
  return null
};

// For rendering flexible component given name and props
export const renderComponent = (component) => {
  const Component = blocks[component.name]
  if (!Component) {
    console.error(`${component.name} tried to render but was not found. Please make sure ${
      component.name
      } is imported in /blocks`)
    return null
  }
  return <Component {...component.props} />
};

export const getComponents = (components, props) => {
  return (
    components.map((component, index) => {
      let Component = null;
      if (component.name) {
        Component = blocks[component.name];
      } else if (component.type) {
        Component = blocks[component.type.displayName.replace('Connect(', '').replace('withDynamicComponents(', '').replace(')', '').replace(')', '')];
        // Component = blocks[component.type.displayName.replace('withDynamicComponents(', '').replace(')', '')];
      }
      if (Component) {
        if (props) {
          return <Component {...component.props} {...props} key={index}/>
        } else {
          return <Component {...component.props} key={index}/>
        }
      } else {
        return null;
      }
    })
  );
};

// パラメータ取得
export const getParams = () => {
  const arr = window.location.search.replace('?', '').split('&');
  let params = {};
  let flg = false;
  let i, max;
  for (i = 0, max = arr.length; i < max; i = i + 1) {
    const pair = arr[i].split('=');
    if (pair[1]) {
      flg = true;
      params[pair[0]] = decodeURIComponent(pair[1]);
    }
  }
  if (flg) {
    return params;
  } else {
    return null;
  }
};

// Cookie設定
export const setCookie = (key, val, expires = 0) => {
  // Secure属性
  let secure = null;
  if (0 <= String(location.hostname).indexOf('localhost')) {
    secure = '';
  } else {
    secure = ';secure';
  }
  // SameSite属性
  let domain = null;
  if (0 <= String(location.hostname).indexOf('localhost')) {
    domain = '';
  } else {
    domain = ';domain=' + String(location.hostname);
  }
  //
  let str = null;
  if (0 < expires) {
    // 期限付き保存
    let date = new Date();
    date.setTime(date.getTime() + expires * 24 * 60 * 60 * 1000);
    str = key + '=' + encodeURIComponent(val) + ';expires=' + date.toGMTString() + domain + ';path=/' + secure + ';samesite=lax';
    document.cookie = str;
  } else {
    // セッション保存
    str = key + '=' + encodeURIComponent(val) + ';path=/' + secure + ';samesite=lax';
    document.cookie = str;
  }
  //console.log('Cookie設定', str);
};

// Cookie削除
export const removeCookie = (key) => {
  // Secure属性
  let secure = null;
  if (0 <= String(location.hostname).indexOf('localhost')) {
    secure = '';
  } else {
    secure = '; secure';
  }
  // SameSite属性
  let domain = null;
  if (0 <= String(location.hostname).indexOf('localhost')) {
    domain = '';
  } else {
    domain = '; domain=' + String(location.hostname);
  }
  document.cookie = key + '=; max-age=0' + domain + '; path=/' + secure + '; samesite=lax';
  //console.log('Cookie削除', key);
};

// Cookie取得
export const getCookie = (key) => {
  let arr = document.cookie.split(';');
  let i, max;
  for (i = 0, max = arr.length; i < max; i = i + 1) {
    let pair = arr[i].split('=');
    if (key === pair[0].trim()) {
      return decodeURIComponent(pair[1]);
    }
  }
  return null;
};

// 大文字を小文字にして、スペースをハイフンにして比較
export const isEqualId = (id = null, id2 = null) => {
  if (id) {
    id = id.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
  }
  if (id2) {
    id2 = id2.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
  }
  if (id === id2) {
    return true;
  } else {
    return false;
  }
};

// 大文字を小文字に、スペースをハイフンにフォーマット
export const formatId = (id = null)=> {
  if (id) {
    return id.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
  } else {
    return id;
  }
};



// WEBPACK FOOTER //
// ./src/containers/utilities/index.jsx